import type {
  FlowRunDto,
  FlowRunMode,
  FlowRunStatus,
} from '@reelplicate/api-client/model';
import { createContext, use } from 'react';

/** How often an open run is polled. */
export const RUN_POLL_MS = 1500;

export const OPEN_RUN: FlowRunStatus[] = ['QUEUED', 'RUNNING', 'WAITING', 'SLEEPING'];
export const isOpen = (run: { status: FlowRunStatus } | undefined) =>
  Boolean(run && OPEN_RUN.includes(run.status));

export type RunState = {
  workspaceId: string;
  /** The run the canvas shows: the latest one, or the one just started. */
  run: FlowRunDto | undefined;
  starting: FlowRunMode | null;
  start: (mode: FlowRunMode) => Promise<void>;
  cancel: () => Promise<void>;
  /** Replaces the shown run (after a rewrite answers with the updated run). */
  show: (run: FlowRunDto) => void;
};

export const RunContext = createContext<RunState | null>(null);

export function useRun(): RunState {
  const state = use(RunContext);
  if (!state) throw new Error('useRun must be used inside the flow editor');
  return state;
}
